import { Component } from '@angular/core';
import { PrimeNGInputMultiSelectComponent } from '@ntap/primeng';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-earhiv-prime-multi-select',
  template: `
    <ng-container *ngIf="inputConfig$ | async as inputConfig">
      <ng-container
        *ngIf="!inputConfig.readOnly; else isReadOnly"
        [formGroup]="(this.formService.formGroup$ | async) ?? defaultFormGroup"
      >
        <p-multiSelect
          [options]="options"
          autoWidth="false"
          [filter]="true"
          [name]="inputConfig.formControlName"
          optionLabel="label"
          defaultLabel="<Odaberite>"
          [required]="isRequired()"
          selectedItemsLabel="{0} stavki odabrano"
          [maxSelectedLabels]="maxSelectedLabels"
          [disabled]="inputConfig.disabled"
          [formControlName]="formControlName"
          appendTo="body"
          [virtualScroll]="true"
          [virtualScrollItemSize]="35"
        ></p-multiSelect>
        <ntap-show-form-errors [control]="formControl"></ntap-show-form-errors>
      </ng-container>
      <ng-template #isReadOnly>
        <ntap-input-label [data]="readonlyValue"></ntap-input-label>
      </ng-template>
    </ng-container>
  `
})
export class EarhivPrimeNGInputMultiSelectComponent extends PrimeNGInputMultiSelectComponent {
  override defaultFormGroup = new FormGroup({});
  override maxSelectedLabels = 10;
}
